import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import user1 from "../../../assets/images/users/avatar-1.jpg";
import ChangePasswordModal from "../../../pages/Authentication/Changepassword"; 

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false); 
  const [logindate, setlogindate] = useState("");
  const [username, setusername] = useState("");
  const [user_Name, setUser_Name] = useState("");
  const [profilePercent, setProfilePercent] = useState(0)
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  useEffect(() => {
   
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser && authUser?.UserInfo?.lastlogin) {
        setlogindate(authUser.UserInfo.lastlogin);
    }
    if (authUser && authUser?.UserInfo?.st_name) {
      setUser_Name(authUser.UserInfo.st_name);
  }
    
  }, []);

  useEffect(() => {
   
    const authUser = JSON.parse(localStorage.getItem("authUser"));


    setProfilePercent(authUser?.UserInfo?.profilePercentage)
    if (authUser && authUser.UserInfo.st_name) {
     
      setusername(authUser.UserInfo.st_name.charAt(0).toUpperCase());
    }
  }, []);

  useEffect(() => {
    // Load from localStorage on mount
    const stored = localStorage.getItem('authUser');
    if (stored) {
      try {
        const json = JSON.parse(stored);
        // alert(json.profileCompleted)
        setProfilePercent(json.UserInfo?.profilePercentage || 0);
      } catch (e) {
        console.error('Invalid JSON in localStorage');
      }
    }

    // Optional: Listen for external storage changes
    const handleStorageChange = () => {
      const updated = localStorage.getItem('authUser');
      if (updated) {
        try {
          const updatedJson = JSON.parse(updated);
          setProfilePercent(updatedJson?.UserInfo?.profilePercentage || 0);
        } catch {}
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  
  const toggleChangePasswordModal = () => {
    setShowChangePasswordModal(!showChangePasswordModal);
  };


  const  getProgressColor = (percent) => {
    if (percent >= 100) return 'bg-success';
    if (percent >= 50) return 'bg-warning';
    return 'bg-danger';
  }
  
  
  const ProgressBar = ({ percent }) => {
    const progressClass = `progress-bar ${getProgressColor(percent)}`;
  
    return (
      <div className="progress" style={{ height: '20px' }}>
      
        <div
          className={progressClass}
          role="progressbar"
          style={{ width: `${percent}%`, padding:'0px 8px' }}
          aria-valuenow={percent}
          aria-valuemin="0"
          aria-valuemax="100"
        >
       {percent}%
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
       
<div style={{marginTop:'25px', fontSize:'10px',marginRight:'10px', fontWeight:'bold'}}>Profile Completion :</div> 

<div style={{marginTop:'25px', fontSize:'10px', minWidth:'220px', marginRight:'10px'}}><ProgressBar percent={profilePercent} /></div>
      {logindate && <div style={{marginTop:'25px', fontSize:'10px'}}>Last Login: {logindate}</div>}
      {!logindate && <div style={{marginTop:'25px', fontSize:'15px'}}>Welcome {user_Name}</div>}
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
      <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
         
          {/* Display the first letter of the username as the profile image */}
          <div className="rounded-circle header-profile-user" style={{ width: '40px', height: '40px', background: '#007bff', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px' }}>
            {username}
          </div>
          {/* <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span> */}
          {/* <i className="mdi mdi-chevron-down d-none d-xl-inline-block" /> */}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}
          </DropdownItem>
          <DropdownItem tag="a" href="#" onClick={toggleChangePasswordModal}> 
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Change Password")}
          </DropdownItem>
          <Link  className="dropdown-item" tag="a"  to="/mysubscription"> 
            <i className="bx bx-purchase-tag font-size-16 align-middle me-1" />
            {props.t("My Subscriptions")}
          </Link>
          {/* <Link to="/mysubscription" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("mysubscription")}</span>
          </Link> */}
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      
      <ChangePasswordModal isOpen={showChangePasswordModal} toggle={toggleChangePasswordModal} />
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(ProfileMenu)));